"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _fill = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/fill"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _recharts = require("recharts");
var _AuComponent = _interopRequireDefault(require("./AuComponent"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "bar_chart-module__container___jYDD_",
  "title": "bar_chart-module__title____oMqI",
  "tooltip": "bar_chart-module__tooltip___APYMT",
  "tooltip_bold": "bar_chart-module__tooltip_bold___Mrfib",
  "tooltip_circle": "bar_chart-module__tooltip_circle___cEFF_",
  "tooltip_text": "bar_chart-module__tooltip_text___mJiht",
  "legend_text": "bar_chart-module__legend_text___gXTLt"
};
const CustomTooltip = ({
  payload
}) => {
  if (payload && payload[0]) {
    let defs = [];
    for (let each in payload) {
      const def = /*#__PURE__*/_react.default.createElement("div", {
        key: each
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: styles.tooltip_circle,
        style: {
          backgroundColor: (0, _fill.default)(payload[each])
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: styles.tooltip_text
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: styles.tooltip_text
      }, payload[each].name, ": "), /*#__PURE__*/_react.default.createElement("div", {
        className: styles.tooltip_text
      }, payload[each].value)));
      defs.push(def);
    }
    const tooltip = /*#__PURE__*/_react.default.createElement("div", {
      key: payload[0].payload.name,
      className: styles.tooltip
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.tooltip_bold
    }, payload[0].payload.name), defs);
    return tooltip;
  }
  return null;
};
class BarChart extends _AuComponent.default {
  static propTypes = {
    maxBarWidth: T.number,
    seriesColors: T.arrayOf(T.string),
    data: T.arrayOf(T.object),
    titleString: T.string,
    titleId: T.string,
    height: T.number,
    width: T.oneOfType([T.number, T.string]),
    seriesLabels: T.arrayOf(T.string),
    dataMax: T.number,
    ticks: T.arrayOf(T.number),
    tickCount: T.number,
    enableTooltip: T.bool
  };
  static defaultProps = {
    maxBarWidth: 40,
    seriesColors: ['#1188AA']
  };

  // For all bar charts, data should be entered as a single array
  // if it is a grouped bar chart, enter the value for each group for a given timeframe/name as a number, with a specific datakey that will be used to identify this group in the Legend
  // for non-grouped bar chart, enter the name of the timeframe/name with the key 'name', and the associated value with the key 'value'
  // enter an array called 'seriesLabels', with the different datakeys for the groups as strings. if it is a non-grouped chart, simply add seriesLabels={['value']}
  // for specific colors, add an array called seriesColors with the different colors as strings in the same order as seriesLabels
  // examples of this are in the component gallery

  calcTickCount(max) {
    const {
      tickCount,
      ticks
    } = this.props;
    if (tickCount && ticks) {
      return [tickCount, ticks];
    }
    let tickC = 4;
    let yMax = max;
    let tick = [];
    if (ticks) {
      tickC = ticks.length;
      return [ticks, tickC];
    }
    if (tickCount) {
      tickC = tickCount;
    } else {
      yMax = Math.ceil(max / 4) * 4;
    }
    let val = 0;
    for (let i = 0; i <= tickC; i++) {
      tick.push(val);
      val += yMax / tickC;
    }
    return [tickCount + 1, yMax, tick];
  }
  renderBars() {
    const {
      seriesLabels,
      seriesColors,
      maxBarWidth
    } = this.props;
    let bars = [];
    for (let idx = 0; idx < seriesLabels.length; ++idx) {
      let axisId = 'left';
      if (idx % 2 == 1) {
        axisId = 'right';
      }
      const bar = /*#__PURE__*/_react.default.createElement(_recharts.Bar, {
        key: seriesLabels[idx],
        dataKey: seriesLabels[idx],
        yAxisId: axisId,
        fill: seriesColors[idx],
        maxBarSize: maxBarWidth
      });
      bars.push(bar);
    }
    return bars;
  }
  render() {
    const {
      width,
      height,
      data,
      titleString,
      dataMax,
      seriesLabels,
      titleId,
      enableTooltip
    } = this.props;
    const multipleSeries = seriesLabels.length > 1;
    const [tickCount, yMax, ticks] = this.calcTickCount(dataMax);
    return /*#__PURE__*/_react.default.createElement(_recharts.ResponsiveContainer, {
      width: width,
      height: height,
      className: styles.container
    }, /*#__PURE__*/_react.default.createElement(_recharts.BarChart, {
      width: width - 64,
      height: height,
      data: data,
      margin: {
        top: 104,
        right: 0,
        left: 0,
        bottom: 30
      }
    }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("foreignObject", {
      x: 38,
      y: 32,
      width: width,
      height: 32
    }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: titleId,
      displayString: titleString,
      className: styles.title,
      tag: "div"
    }))), /*#__PURE__*/_react.default.createElement(_recharts.CartesianGrid, {
      vertical: false
    }), /*#__PURE__*/_react.default.createElement(_recharts.XAxis, {
      dataKey: "name",
      tickMargin: 7,
      tickLine: false,
      interval: 0,
      tick: {
        fill: '#324661',
        opacity: 0.7,
        fontSize: 12,
        lineHeight: 17
      },
      color: "#9B9B9B"
    }), /*#__PURE__*/_react.default.createElement(_recharts.YAxis, {
      domain: [0, yMax],
      ticks: ticks,
      tickCount: tickCount,
      tickLine: false,
      yAxisId: "left",
      orientation: "left",
      tick: {
        fill: '#1B2F4B',
        opacity: 0.6,
        fontSize: 12,
        lineHeight: 17
      },
      axisLine: false
    }), /*#__PURE__*/_react.default.createElement(_recharts.YAxis, {
      domain: [0, yMax],
      ticks: ticks,
      tickCount: tickCount,
      tickLine: false,
      yAxisId: "right",
      orientation: "right",
      tick: {
        fill: '#1B2F4B',
        opacity: 0.6,
        fontSize: 12,
        lineHeight: 17
      },
      axisLine: false
    }), multipleSeries && /*#__PURE__*/_react.default.createElement(_recharts.Legend, {
      formatter: value => {
        // TODO: Should formatters be passed in?
        return /*#__PURE__*/_react.default.createElement("span", {
          className: styles.legend_text
        }, value);
      },
      wrapperStyle: {
        top: 40,
        lineHeight: '20px',
        fontSize: '14px',
        right: 28
      },
      align: "right"
    }), this.renderBars(), enableTooltip && /*#__PURE__*/_react.default.createElement(_recharts.Tooltip, {
      cursor: {
        fill: 'transparent'
      },
      content: /*#__PURE__*/_react.default.createElement(CustomTooltip, null)
    })));
  }
}
exports.default = BarChart;